module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1988458"
    }
  }, [_c('b', [_vm._v("CHILLED TUSCAN-STYLE TOMATO SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1989258"
    }
  }, [_c('b', [_c('i', [_vm._v("Summer in a bowl: the uncooked version of ")]), _vm._v("Papa al Pomodoro, "), _c('i', [_vm._v("Italy’s famous bread-thickened tomato soup.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1990758"
    }
  }, [_c('b', [_vm._v("Prep: 15 minutes plus chilling Cook: 1 minute")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1991258"
    }
  }, [_vm._v("1 teaspoon olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1991558"
    }
  }, [_vm._v("1 clove garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1991858"
    }
  }, [_vm._v("3 ounces country-style bread, "), _c('br'), _vm._v(" cut into 1-inch cubes (2 cups)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1992458"
    }
  }, [_vm._v("3 pounds ripe tomatoes (9 medium), cut into "), _c('br'), _vm._v(" quarters")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1993158"
    }
  }, [_vm._v("¼ cup loosely packed fresh basil leaves, "), _c('br'), _vm._v(" chopped, plus additional leaves for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1994358"
    }
  }, [_vm._v("1 teaspoon sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1994658"
    }
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1995858"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In small skillet, heat oil on medium until hot. Add garlic and cook 1 minute, stirring. Remove skillet from heat.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1997458"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In food processor with knife blade attached, pulse bread until coarsely chopped. Add tomatoes and garlic; pulse until soup is almost pureed. Pour soup into bowl; stir in chopped basil, sugar, and salt. Cover and refrigerate until well chilled, at least 2 hours or overnight. Garnish each serving with basil leaves. Makes about 6 cups or 4 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2000558"
    }
  }, [_vm._v("Each serving: About 145 calories, 5g protein, 28g carbohydrate, 3g total fat (1g saturated), 4g fiber, 0mg cholesterol, 445mg sodium.")]), _vm._v(" "), _c('div', {
    staticClass: "side"
  }, [_c('p', {
    staticClass: "sidebarh3",
    staticStyle: {
      "color": "#8A4117"
    },
    attrs: {
      "id": "d7e2003558"
    }
  }, [_c('b', [_vm._v("5 IDEAS FOR . . . TOMATO-VEGETABLE JUICE")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2004258"
    }
  }, [_vm._v("No matter which brand of tomato-veggie juice you prefer, the typical 8-ounce glassful delivers two healthy servings of vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2005558"
    }
  }, [_c('b', [_vm._v("ALPHABET SOUP")]), _c('br'), _vm._v(" In 5-quart saucepot, combine 1 package (32 ounces) chicken broth, 4 cups vegetable juice, 1 package (16 ounces) frozen mixed vegetables, ½ teaspoon Italian seasoning, and ¼ teaspoon ground black pepper. Cover saucepot; heat to boiling. Stir in 1 cup uncooked alphabet pasta or orzo. Simmer soup, uncovered, on medium low 8 minutes or until pasta and vegetables are tender. Serves 6.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2011358"
    }
  }, [_c('b', [_vm._v("PECORINO-PEPPER BISCUITS")]), _c('br'), _vm._v(" Prepare 1 batch all-purpose pancake-and-baking mix as label directs for drop biscuits with following alterations: Stir ¼ cup freshly grated Pecorino-Romano cheese and ¼ teaspoon coarsely ground black pepper into dry mix, and substitute vegetable juice for milk. Drop dough by scant ¼ cup onto ungreased large cookie sheet and bake as label directs. Makes 9 biscuits.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2018558"
    }
  }, [_c('b', [_vm._v("SPICY RED RICE")]), _c('br'), _vm._v(" In 3-quart saucepan, heat 2 teaspoons vegetable oil, cook 1 large onion, chopped, on medium 6 minutes or until softened. Stir in ¾ cup long-grain white rice and ¼ teaspoon dried rosemary; cook 1 minute. Stir in 3 cup spicy vegetable juice and ¼ teaspoon salt; heat to boiling. Cover and simmer on low 20 to 24 minutes, until rice is tender and liquid is absorbed. Stir in ½ cup toasted slivered almonds. Serves 4.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2026558"
    }
  }, [_c('b', [_vm._v("SPANISH MEAT BALLS")]), _c('br'), _vm._v(" In 12-inch skillet, combine 3 cups vegetable juice, 2 tablespoons seasoned dried bread crumbs, and ½ teaspoon each ground cumin and smoked paprika; heat to boiling. Simmer, uncovered, on medium low18 minutes to thicken slightly. Meanwhile, in bowl, mix 1 pound lean (90%) ground beef with ⅓ cup seasoned dried bread crumbs, ⅓ cup vegetable juice, and ½ teaspoon smoked paprika. Shape into 1-inch balls; drop into hot sauce, and simmer 12 to 14 minutes or until cooked through. Serve over rice. Serves 4.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2035058"
    }
  }, [_c('b', [_vm._v("SAUSAGE CHILI")]), _c('br'), _vm._v(" Remove casings from 1 package (1¼ pounds) turkey Italian sausage links and crumble. In 5-quart Dutch oven, cook sausage and 2 chopped medium onions, on medium 8 minutes or until onions soften. Stir in 1½ tablespoons chili powder; cook 2 minutes. Add 4 cups spicy vegetable juice; heat to boiling. Simmer, uncovered, on low 15 minutes. Stir in 2 cans (15 to 19 ounces each) red kidney beans, rinsed and drained; heat through. Serves 6.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06c2f780","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c56_r1.vue
// module id = 234
// module chunks = 0